<template>
    <form
        v-if="(!!delform || !!postform) && !!href"
        class="btn-form"
        method="POST"
        :action="href"
        @submit="clickLink"
    >
        <form-input type="hidden" name="_token" :value="token"></form-input>
        <form-input
            type="hidden"
            name="_method"
            :value="formMethod"
        ></form-input>

        <button
            :class="classObject"
            type="submit"
            :id="id"
            :title="!!label ? label : title"
            :disabled="disabled"
        >
            <spinner :small="true" v-if="!!loading"></spinner>
            <span
                class="btn-content-icon"
                :class="classIconObject"
                v-if="!!icon && icon.length > 0 && !loading"
                ><font-awesome-icon :icon="icon"></font-awesome-icon
            ></span>
            <span class="btn-content-title" v-if="!!title && !loading">{{
                title
            }}</span>
        </button>
    </form>
    <a
        :class="classObject"
        :id="id"
        :href="href"
        :title="!!label ? label : title"
        :disabled="disabled"
        v-else-if="!delform && !postform && !!href"
        :target="target"
        @click="clickLink"
    >
        <spinner :small="true" v-if="!!loading"></spinner>
        <span
            class="btn-content-icon"
            :class="classIconObject"
            v-if="!!icon && icon.length > 0 && !loading"
            ><font-awesome-icon :icon="icon"></font-awesome-icon
        ></span>
        <div class="btn-content-image" v-if="!!src && !loading">
            <img :src="src" :alt="title" />
        </div>
        <span class="btn-content-title" v-if="!!title && !loading">{{
            title
        }}</span>
        <div class="btn-content-badge" v-if="!!badge && !loading">
            {{ badge }}
        </div>
    </a>
    <button
        :class="classObject"
        :type="!!submit ? 'submit' : 'button'"
        :id="id"
        :title="!!label ? label : title"
        :disabled="disabled"
        @click="clickObject"
        v-else
    >
        <spinner :small="true" v-if="!!loading"></spinner>
        <span
            class="btn-content-icon"
            :class="classIconObject"
            v-if="!!icon && icon.length > 0 && !loading"
            ><font-awesome-icon :icon="icon"></font-awesome-icon
        ></span>
        <div class="btn-content-image" v-if="!!src && !loading">
            <img :src="src" :alt="title" />
        </div>
        <span class="btn-content-title" v-if="!!title && !loading">{{
            title
        }}</span>
        <div class="btn-content-badge" v-if="!!badge && !loading">
            {{ badge }}
        </div>
    </button>
</template>

<script>
export default {
    data: () => ({
        token: null,
        loading: false
    }),
    props: {
        type: {
            type: String,
            default: "primary",
            required: false
        },
        icon: {
            type: Array,
            default: null,
            required: false
        },
        size: {
            type: String,
            default: null,
            required: false
        },
        iconSize: {
            type: String,
            default: null,
            required: false
        },
        block: {
            type: Boolean,
            default: false,
            required: false
        },
        bar: {
            type: Boolean,
            default: false,
            required: false
        },
        header: {
            type: Boolean,
            default: false,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        active: {
            type: Boolean,
            default: false,
            required: false
        },
        light: {
            type: Boolean,
            default: false,
            required: false
        },
        table: {
            type: Boolean,
            default: false,
            required: false
        },
        href: {
            type: String,
            default: null,
            required: false
        },
        id: {
            type: String,
            default: null,
            required: false
        },
        title: {
            type: String,
            default: null,
            required: false
        },
        label: {
            type: String,
            default: "",
            required: false
        },
        action: {
            type: Function,
            default: null,
            required: false
        },
        submit: {
            type: Boolean,
            default: false,
            required: false
        },
        src: {
            type: String,
            default: null,
            required: false
        },
        badge: {
            type: [String, Number],
            default: null,
            required: false
        },
        postform: {
            type: Boolean,
            default: false,
            required: false
        },
        delform: {
            type: Boolean,
            default: false,
            required: false
        },
        formid: {
            type: String,
            default: null,
            required: false
        },
        target: {
            type: String,
            default: null,
            required: false
        },
        setLoading: {
            type: Boolean,
            default: null,
            required: false
        },
        round: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        classObject: function() {
            return {
                btn: true,
                ["btn-" + this.type]: !this.header,
                "btn-icon": !!this.isOnlyIcon,
                "btn-sm": this.size == "small",
                "btn-lg": this.size == "large",
                "btn-block": !!this.block,
                "btn-bar": !!this.bar,
                "btn-table": !!this.table,
                "btn-header": !!this.header,
                active: !!this.active,
                "btn-outline": !!this.light,
                "btn-loading": !!this.loading,
                "btn-round": !!this.round
            };
        },
        classIconObject: function() {
            return {
                "icon-large": this.iconSize == "large",
                "icon-small": this.iconSize == "small"
            };
        },
        formMethod: function() {
            if (!!this.delform) return "DELETE";
            if (!!this.postform) return "POST";
            return null;
        },
        isOnlyIcon: function() {
            return !!this.icon && !this.title;
        }
    },
    methods: {
        clickObject: function() {
            if (!!this.loading || !!this.disabled) {
                return false;
            }

            //this.loading = true;

            if (!!this.formid) {
                return this.$root.submitForm(this.formid);
            } else if (!!this.action) {
                return this.action.apply(this);
                this.loading = false;
            }

            return true;
        },
        clickLink: function() {
            if (!!this.loading || !!this.disabled) {
                return false;
            }

            //this.loading = true;

            return true;
        }
    },
    created: function() {
        if (this.setLoading === true || this.setLoading === false)
            this.loading = this.setLoading;

        if (!!this.delform || !!this.postform) {
            let token = document.head.querySelector('meta[name="csrf-token"]');

            if (token) this.token = token.content;
        }
    },
    updated: function() {
        if (this.setLoading === true || this.setLoading === false)
            this.loading = this.setLoading;
    }
};
</script>
